"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = exports.TestSuite = void 0;
var utils_1 = require("@time-input-polyfill/utils");
var TestSuite = /** @class */ (function () {
    function TestSuite(utils) {
        var _this = this;
        this.all = function () {
            Object.keys(_this).forEach(function (key) {
                var fn = _this[key];
                if (typeof fn === 'function' && key !== 'all') {
                    fn(utils);
                }
            });
        };
    }
    return TestSuite;
}());
exports.TestSuite = TestSuite;
var Utils = /** @class */ (function () {
    function Utils(_a) {
        var _this = this;
        var IDsAndLabels = _a.IDsAndLabels, localHostUrl = _a.localHostUrl;
        this.loadPrimaryInput = function (params) { return _this.loadTestPage(__assign({ polyfillId: _this.IDs.primaryInputID }, params)); };
        this.loadEventsInput = function (params) { return _this.loadTestPage(__assign({ polyfillId: _this.IDs.eventsInputID }, params)); };
        this.cyInput = function () { return cy.get("#".concat(_this.IDs.primaryInputID)); };
        this.cyA11y = function () { return cy.get("#".concat(_this.IDs.a11yID)); };
        this.hasReturnVal = function (expectation) { return function () {
            return cy.get("#".concat(_this.IDs.primaryValueID))
                .wait(10)
                .should('have.text', expectation)
                .then(_this.cyInput);
        }; };
        this.sendFocus = function () { return _this.cyInput().focus().wait(100); };
        this.localHostUrl = localHostUrl;
        this.labels = IDsAndLabels.labels;
        this.IDs = IDsAndLabels.IDs;
        this.use = {
            upArrow: function () { return _this.cyInput().trigger('keydown', { key: 'ArrowUp' }).trigger('keyup', { key: 'ArrowUp' }).wait(10); },
            downArrow: function () { return _this.cyInput().trigger('keydown', { key: 'ArrowDown' }).trigger('keyup', { key: 'ArrowDown' }).wait(10); },
            leftArrow: function () { return _this.cyInput().trigger('keydown', { key: 'ArrowLeft' }).trigger('keyup', { key: 'ArrowLeft' }).wait(10); },
            rightArrow: function () { return _this.cyInput().trigger('keydown', { key: 'ArrowRight' }).trigger('keyup', { key: 'ArrowRight' }).wait(10); },
            // Tab can't be tested due to e.preventDefault() not being supported
            // tab: () => cyInput().tab(),
            // shiftTab: () => cyInput().tab({ shift: true }),
            del: function () { return _this.cyInput().trigger('keydown', { key: 'Delete' }).trigger('keyup', { key: 'Delete' }).wait(10); },
            backspace: function () { return _this.cyInput().trigger('keydown', { key: 'Backspace' }).trigger('keyup', { key: 'Backspace' }).wait(10); }
        };
        // `this` isn't always defined. Have to force it to get bound correctly using this method :(
        // https://stackoverflow.com/questions/4011793/this-is-undefined-in-javascript-class-methods
        var bind = function (key) { _this[key] = _this[key].bind(_this); };
        bind('loadTestPage');
        bind('loadPrimaryInput');
        bind('loadEventsInput');
        bind('cyInput');
        bind('cyA11y');
        bind('cySelectSegment');
        bind('$input');
        bind('hasReturnVal');
        bind('a11yInitialHtml');
        bind('a11yHasExpectedHtml');
        bind('sendFocus');
        bind('setTime');
        bind('clearAllSegments');
    }
    Utils.prototype.loadTestPage = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, segment = _b.segment, polyfillId = _b.polyfillId, _c = _b.url, url = _c === void 0 ? this.localHostUrl : _c;
        return cy.visit(url).wait(100).then(function () {
            if (segment) {
                return _this.cySelectSegment(segment);
            }
            return cy.get("#".concat(polyfillId)).wait(10);
        });
    };
    Utils.prototype.$input = function (jQueryInput) {
        return jQueryInput[0];
    };
    Utils.prototype.a11yInitialHtml = function (value) {
        var hrs12 = "<p>Hours spin button ".concat(value || 8, ".</p>");
        return ({
            hrs12: hrs12,
            minutes: "<p>Minutes spin button ".concat(value || 30, ".</p>"),
            mode: "<p>AM/PM spin button ".concat(value || 'PM', ".</p>"),
            focus: "<p>".concat(this.labels.primaryTestsLabel, " grouping ").concat((0, utils_1.toLeadingZero)(value || 8), ":30 PM.</p>") + hrs12
        });
    };
    Utils.prototype.a11yHasExpectedHtml = function (expectedHtml) {
        var _this = this;
        return function () { return _this.cyA11y().wait(10).should('have.html', expectedHtml).then(_this.cyInput); };
    };
    Utils.prototype.cySelectSegment = function (segmentToEndOn) {
        var _this = this;
        var inputSelection = this.sendFocus();
        var targets = {
            hrs12: function () { return inputSelection; },
            minutes: function () { return inputSelection.then(_this.use.rightArrow); },
            mode: function () { return inputSelection.then(_this.use.rightArrow).then(_this.use.rightArrow); },
        };
        return targets[segmentToEndOn]().wait(100);
    };
    Utils.prototype.setTime = function (string12hr, finishingSegment) {
        var _this = this;
        if (finishingSegment === void 0) { finishingSegment = 'hrs12'; }
        var regex = /(\d\d):(\d\d) ([AP]M)/i;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _a = regex.exec(string12hr) || [], _match = _a[0], hrs12 = _a[1], minutes = _a[2], mode = _a[3];
        var inputSelection = this.cySelectSegment('hrs12').type("".concat(hrs12).concat(minutes).concat(mode));
        var targets = {
            hrs12: function () { return inputSelection.then(_this.use.leftArrow).then(_this.use.leftArrow); },
            minutes: function () { return inputSelection.then(_this.use.leftArrow); },
            mode: function () { return inputSelection; },
        };
        return targets[finishingSegment]();
    };
    Utils.prototype.clearAllSegments = function (segmentToEndOn) {
        var _this = this;
        return this.cyInput().focus().type('{del}').should('have.value', '--:30 PM')
            .then(function () { return _this.use.rightArrow(); })
            .then(function () { return _this.cyInput().type('{del}').should('have.value', '--:-- PM'); })
            .then(function () { return _this.use.rightArrow(); })
            .then(function () { return _this.cyInput().type('{del}').should('have.value', '--:-- --'); })
            .then(function () { return _this.cyInput().blur(); })
            .then(function () { return _this.cySelectSegment(segmentToEndOn); });
    };
    return Utils;
}());
exports.Utils = Utils;
